import React from 'react';
import PropTypes from 'prop-types';
import { FormField } from '../components/Form/FormField';
import { FAIcon } from '../components/fa-icon';
import { formatClassName } from '../utils';

export class FloatingLabelFormField extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    as: PropTypes.string,
    dataValue: PropTypes.any,
    disabled: PropTypes.bool,
    isFloatOutside: PropTypes.bool,
    labelClassName: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    populatedOverride: PropTypes.bool,
    searchField: PropTypes.bool,
    tooltip: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
  };

  constructor(props) {
    super(props);
    const populated = props.dataValue !== undefined && props.dataValue !== null && props.dataValue !== '';
    this.state = {
      toggled: false,
      populated,
    };
  }

  onFocus = () => {
    if (typeof this.childFocus === 'function') {
      this.childFocus();
    }
    this.setState({ toggled: true });
  };

  onChange = value => {
    if (typeof this.childChange === 'function') {
      this.childChange(value);
    }
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value);
    }
    this.setPopulated(value);
  };

  onBlur = value => {
    if (typeof this.childBlur === 'function') {
      this.childBlur(value);
    }
    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(value);
    }
    this.setPopulated(value);
    this.setState({ toggled: false });
  };

  onDataLoaded = value => {
    this.setPopulated(value);
  };

  setPopulated = value => {
    let present = !!value;
    if (value instanceof Array) {
      present = value.length > 0;
    }
    if (this.state.populated !== present) {
      this.setState({ populated: present });
    }
  };

  renderField = () => {
    if (this.props.children) {
      const child = React.Children.only(this.props.children);
      this.childBlur = child.props.onBlur;
      this.childChange = child.props.onChange;
      this.childFocus = child.props.onFocus;
      this.childType = child.type;
      this.fieldClassName = child.props.fieldClassName;
      return React.cloneElement(child, {
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onDataLoaded: this.onDataLoaded,
      });
    }
  };

  render() {
    const { as, className, disabled, labelClassName, populatedOverride, searchField, tooltip } = this.props;
    const { populated, toggled } = this.state;

    const wrapperClassName = formatClassName([
      'fg-line',
      'ui-default',
      'regular',
      as,
      this.fieldClassName,
      { 'fg-disabled': disabled },
      { 'fg-populated': !populatedOverride && populated },
      { 'fg-toggled': toggled },
      { 'fg-tooltip': tooltip },
    ]);

    const labelClass = formatClassName([labelClassName, 'fg-label']);

    return (
      <FormField
        {...this.props}
        className={className + ' fg-float'}
        onBlur={this.onBlur}
        onChange={this.onChange}
        onFocus={this.onFocus}
        inputClassName="fg-input"
        tooltip={tooltip}
        searchField={searchField ? <FAIcon icon="search" /> : null}
        labelClassName={labelClass}
        wrapperClassName={wrapperClassName}
      >
        {this.renderField()}
      </FormField>
    );
  }
}
